<template>
  <form v-on:submit.prevent="submitHandler">
    <div
      v-for="(question, index) in questionnary.questions"
      :key="`question-${index}`"
    >
      <v-row v-if="question.is_public" class="ma-0 pa-0">
        <v-col
          v-if="[ 7, 10 ].includes(question.question_type_id)"
          class="ma-0 pa-0"
          cols="4"
        >
          <article v-if="inputLabel($t('code'))" class="form-control-label">
            {{ inputLabel($t('code')) }}
          </article>
          <v-select
            :label="$t('code').length <= 25 ? $t('code') : null"
            v-model="countries.code"
            :items="countries.list"
            item-text="nameCode"
            item-value="dial_code"
            outlined
            hide-details
            required
            class="mr-3 os-rounded"
            @change="validateBeforeSubmit()"
            dense
            :disabled="loading"
            :color="color"
          ></v-select>
        </v-col>
        <v-col
          class="ma-0 pa-0"
          :cols="[ 7, 10 ].includes(question.question_type_id) ? 8 : 12"
        >
          <article v-if="inputLabel(question.question)" class="form-control-label">
            {{ inputLabel(question.question) }}
          </article>
          <v-select
            :label="question.question.length <= 25 ? question.question : null"
            v-if="question.question_type_id === 2"
            :placeholder="question.description"
            v-model="form[question.reference]"
            :items="question.answers"
            item-text="answer"
            outlined
            hide-details
            :required="question.is_required"
            class="me-1 os-rounded"
            dense
            :disabled="loading"
            :color="color"
          ></v-select>
          <v-text-field
            v-else
            class="os-rounded"
            persistent-placeholder
            :label="question.question.length <= 25 ? question.question : null"
            :placeholder="question.description"
            :required="question.is_required"
            :type="setInputType(question.question_type_id)"
            v-model="form[question.reference]"
            outlined
            :hide-details="!errorIndex(index)"
            @keyup="validateIdentification(question.question_type_id, question.reference)"
            :error-messages="errorMessaje(question.question_type_id, question.question, index)"
            :error="errorIndex(index)"
            @blur="validateFields(form[question.reference], question.question_type_id, index, question.is_required)"
            dense
            :disabled="loading"
            :color="color"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <section class="form-actions d-flex justify-end">
      <Button
        :block="false"
        :loading="loading"
        :disabled="loading"
        type="submit"
        :color="color"
        :dark="true"
      >
        {{ $t('basics.continue') }}
      </Button>
    </section>
  </form>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import countries from '@/resources/json/countries.json'

require('@/plugins/FormErrorValidator')

@Component({
  components: {
    Button: () => import('@/components/ui/Button.vue')
  },
  props: {
    questionnary: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  }
})
export default class Form extends Vue {
  data () {
    return {
      form: {},
      countries: {
        list: countries,
        code: countries[0].dial_code
      },
      validateError: {}
    }
  }

  formatData (answers) {
    const questionnary = this.questionnary
    const questions = questionnary.questions.filter((question) => question.is_public)
    const result = answers.map((answer, index) => {
      const question = questions[index]
      const { id, question_type_id, reference, answers } = question
      const value = this.form[answer] ?? null

      const answerText = [ 7, 10 ].includes(question_type_id) ? `${this.countries.code}${value}` : value;

      return {
        questionId: id,
        questionTypeId: question_type_id,
        answerId: answers.length ? answers[0].id : null,
        reference,
        answer: answerText
      }
    })

    return result
  }

  submitHandler() {
    if (this.validateBeforeSubmit()) return
    const data = this.formatData(Object.keys(this.form))
    this.$emit('submit', data)
  }

  listCountryCodeAndName () {
    for (let index = 0; index < this.countries.list.length; index++) {
      const country = this.countries.list[index]
      country.nameCode =  `${country.dial_code} - ${country.name}`
    }

    this.countries.list.sort((a, b) => {
      return  (a.name > b.name) ? 1 : (a.name < b.name) ? -1 : 0
    })
  }

  validateIdentification (typeId, reference) {
    let value = this.form[reference]

    if (value) {
      let length = value.length

      if (typeId === 9 && value && length > 2) {
        if (value.split('-')) {
          value = value.split('-').join('')
          length = value.length
        }
        let lastCharacter = value.slice(-1)

        if (lastCharacter === 'k') {
          lastCharacter = 'K'
        }
        const newValue =  `${value.slice(0, (length - 1))}-${lastCharacter}`
        this.form[reference] = newValue
        this.rutError = false
        this.$forceUpdate()
      }
    }
  }

  errorIndex (index) {
    return this.validateError[index]?.error;
  }

  errorMessaje (typeId, question, index) {
    if (this.validateError[index]?.error) return this.validateError[index]?.message
  }

  validateFields (value, typeId, index, required = true) {
    if (!value && !required) {
      this.$set(this.validateError, index, { error: false, message: null })
      return false
    } else if (typeId === 10) {
      value = `${this.countries.code}${value}`
    }

    let { error, message } = this.$FormErrorValidator.validateFields(value, typeId);

    if (typeId == 9) {
      this.rutError = error
    }

    this.$set(this.validateError, index, { error, message })
  }

  validateBeforeSubmit() {
    const questions = this.questionnary.questions;

    for (let index=0; index < (Object.keys(questions)).length; index++) {
      const question = questions[index]
      this.validateFields(this.form[question.reference], question.question_type_id, index, question.is_required)
    }

    for (let key in this.validateError) {
      if (this.validateError[key] && this.validateError[key]?.error) {
        return true
      }
    }
  }

  setInputType (typeId) {
    let type = ''

    switch (typeId) {
      case 3:
        type = 'text'
        break
      case 4:
        type = 'text'
        break
      case 7:
        type = 'tel'
        break
      case 5:
        type = 'email'
        break
      default:
        type = ''
        break
    }

    return type
  }

  inputLabel (label) {
    return label.length > 25 ? label : null
  }

  initForm () {
    if (Vue.prototype.$cityMap.country.iso) {
      const country =  this.countries.list.find((item) => item.code === Vue.prototype.$cityMap.country.iso)

      if (country) {
        this.countries.code = country.dial_code
      }
    }

    this.questionnary.questions.forEach((question) => {
      if (question.is_public) {
        this.$set(this.form, question.reference, '')
      }
    })
  }

  mounted() {
    this.listCountryCodeAndName()
    this.initForm()
  }
}
</script>

<style>
form > div {
  margin-bottom: 15px !important;
}

form > div:last-child {
  margin-bottom: 0;
}
</style>
